import PrimerValidationErrorPropsAndroid from "../../../../content/sdk/android/2.x.x/common/primerValidationErrorProps.mdx";
import ValidationErrors from '/content/sdk/common/2.x.x/validationErrors.mdx';
import * as React from 'react';
export default {
  PrimerValidationErrorPropsAndroid,
  ValidationErrors,
  React
};